/** 动态监控 */
import React from 'react';
import { Input, InputGroup, Icon, Toggle, DatePicker, ButtonToolbar, Button } from 'rsuite';
import moment from 'moment'
import Config from '../config/Config';
import Widget from '../widget/Widget';
import WidgetAjax from '../widget/WidgetAjax';
import WidgetTable from '../widget/WidgetTable';
import WidgetModal from '../widget/WidgetModal';
import WidgetMessage from '../widget/WidgetMessage';
import WidgetDatePicker from '../widget/WidgetDatePicker';
import WidgetSelect from '../widget/WidgetSelect';
import WidgetDrawer from '../widget/WidgetDrawer';
import WidgetPageTable from '../widget/WidgetPageTable';
import EntityDetail from './EntityDetail';
import { Dropdown } from 'rsuite';
import WidgetCondition from '../widget/WidgetCondition';
import Magnifier from "../img/BusinessChance/Magnifier-1.svg"
import Cache from '.././frame/Cache';

import '../css/analysis.css';
import '../css/RiskMonitor.css';
import '../css/scrm.table.css'

class RiskMonitor extends React.Component 
{
    constructor(props) 
    {
        super(props);

        let risk;

        if (this.props.location !== undefined && this.props.location.state !== undefined) 
        {
            risk = this.props.location.state.risk;
        }

        this.state = {
            basePath: Config.getBasePath(),
            keyWord: undefined,
            tabs: [
                { title: "监控列表", key: 1 },
                { title: "监控企业", key: 0 },
                { title: "监控事项", key: 2 }
            ],
            dateOptions: {
                dateType: "date",
                datePickerType: 'range',
                isLeftTitle: false
            },
            earlyWarningColumns: [
                { name: 'ENTID', title: 'ENTID', type: 'string', description: '主体ID', properties: { hidden: true } },
                { name: 'ENTNAME', title: '主体名称', type: 'string', description: '主体名称', properties: { hidden: false, click:"earlyWarningEntityDetail" } },
                { name: 'TYPE_CN', title: '监控类型', type: 'string', description: '监控类型', properties: { hidden: false, width: 10, height: 55 } },
                { name: 'TYPE', title: 'TYPE', type: 'string', description: 'TYPE', properties: { hidden: true } },
                { name: 'CONTENT', title: '预警内容', type: 'string', description: '预警内容', properties: { hidden: false, width: 50 } },
                { name: 'WARNDATE', title: '预警日期', type: 'string', description: '预警日期', properties: { hidden: false, width: 10 } }
            ],
            monitoringColumn: [
                { name: 'MONITOR', title: '监控状态', type: 'string', description: '是否监控', properties: { hidden: true } },
                { name: 'NAME', title: '监控事项', type: 'string', description: '监控事项', properties: { hidden: false, width: 15 } },
                // { name: 'TYPE', title: '', type: 'string', description: '监控类型', properties: { hidden: false, width:8, transform : "transformTYPE"}},
                { name: 'DESCRIPTION', title: '事项说明', type: 'string', description: '事项说明', properties: { hidden: false } },
                {
                    name: 'operation', title: '操作', type: 'string', description: '操作',
                    properties: { hidden: false, width: 10, operations: [{ name: '开关', click: "toggle" }], transform: "transformToggleOperations" }
                },
            ],
            monitoringOptions: {
                records: 1000,
                isAutoHeight: true
            },
            monitorSettingData: undefined,
            options: {
                records: 10,
                rowKey: "ENTID",
                keyWordColumnName: "ENTNAME",
                keyWord: undefined,
                checkedKey: "ENTID",
                check: true,
                isAutoHeight: true,
            },
            columns: [
                [
                    { name: 'ENTID', title: 'ENTID', type: 'string', description: '主体ID', properties: { hidden: true } },
                ],
                [
                    { name: 'MONITOR', title: 'MONITOR', type: 'string', description: '监控状态', properties: { hidden: true } },
                    { name: 'ENTNAME', type: 'string', description: '市场主体名称', properties: { hidden: false, click: "entityDetail" } },
                    { name: 'REGSTATE', type: 'string', description: '企业状态', properties: { hidden: false } },
                ],
                [
                    { name: 'TAGS', type: 'string', description: '主体标签', properties: { hidden: false, type: "label" } }
                ],
                [
                    { name: 'DOM', title: '经营地址', type: 'string', description: '经营地址', properties: { hidden: false } },
                    { name: 'INDUSTRYPHY', title: '行业类型', type: 'string', description: '行业类型', properties: { hidden: false } },
                    { name: 'REGCAP', title: '注册资本', type: 'string', description: '注册资本', properties: { hidden: false, unit:"万元" } },
                    { name: 'ESTDATE', title: '成立时间', type: 'string', description: '成立时间', properties: { hidden: false } }
                ],
                [
                    { name: 'TEL', title: '联系方式', type: 'string', description: '联系方式', properties: { hidden: false, transform: "transformTEL"} },
                ],
                [
                    {
                        name: 'operation', type: 'string', description: '操作', properties: {
                            operations: [
                                { name: '取消监控', click: "removeMonitor" },

                                { name: '添加CRM', click: "addCRM" },
                                { name: '取消CRM', click: "removeCRM" },

                                // { name: '添加种子企业', click: "addFavor"},
                                // { name: '取消种子企业', click: "removeFavor"},
                            ],
                            transform: "transformOperations"
                        }
                    }

                ]
            ],
            earlyWarningData: undefined,
            earlyWarningOptions: {
                record: 10,
                isAutoHeight: true,
                headerHeight: 55
            },
            earlyWarningTotal: undefined,

            messageOptions: {
                title: '信息',
            },
            enterprise: {
                title: '添加监控对象',
                confirm: '确定'
            },
            enterpriseText: {
                title: '批量添加'
            },
            riskType: risk !== undefined ? risk : 1,
            checkedKeys: undefined,
            data: undefined,
            relevance: [],
            input: undefined,
            OBJID: undefined,
            entityData: undefined,
            drawerOptions: {
                size: 'lg',
                button: false,
            },
            detailData: undefined,
            isBatch: false,
            checkData: [],
            rangDate: { startDate: '', endDate: '' },
            flags: false,
            loading:true,
            isLoading:true
        }

        this.delete = this.delete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.onDelete = this.onDelete.bind(this);

        this.changeTab = this.changeTab.bind(this);

        this.remove = this.remove.bind(this);
        this.searchData = this.searchData.bind(this);
        this.onSearchData = this.onSearchData.bind(this);
        this.onEvent = this.onEvent.bind(this);
        this.confirmAdd = this.confirmAdd.bind(this);
        this.pageTurning = this.pageTurning.bind(this);
        this.onReadEntity = this.onReadEntity.bind(this);
        this.tableOnCheck = this.tableOnCheck.bind(this);
        this.InputOnchange = this.InputOnchange.bind(this);
        this.confirmRemove = this.confirmRemove.bind(this);
        this.keyWordOnChange = this.keyWordOnChange.bind(this);

        this.loadMonitorSetting = this.loadMonitorSetting.bind(this);
        this.onLoadMonitorSetting = this.onLoadMonitorSetting.bind(this);

        this.loadMonitorSettingInfo = this.loadMonitorSettingInfo.bind(this);
        this.onLoadMonitorSettingInfo = this.onLoadMonitorSettingInfo.bind(this);

        this.transformIcon = this.transformIcon.bind(this);
        this.transformTEL = this.transformTEL.bind(this);
        this.transformOperations = this.transformOperations.bind(this);
        this.transformToggleOperations = this.transformToggleOperations.bind(this);

        this.riskMonitorUpdateSetting = this.riskMonitorUpdateSetting.bind(this);
        this.onRiskMonitorUpdateSetting = this.onRiskMonitorUpdateSetting.bind(this);
        this.relevanceSearch = this.relevanceSearch.bind(this);
        this.onconfirmRemove = this.onconfirmRemove.bind(this);
        this.onRelevanceSearch = this.onRelevanceSearch.bind(this);

        this.loadEarlyWarningData = this.loadEarlyWarningData.bind(this);
        this.onLoadEarlyWarningData = this.onLoadEarlyWarningData.bind(this);

        this.earlyWarningPageTurning = this.earlyWarningPageTurning.bind(this);

        this.addMonitor = this.addMonitor.bind(this);
        this.addMonitorConfirm = this.addMonitorConfirm.bind(this);
        this.onAddMonitor = this.onAddMonitor.bind(this);
        
        this.removeMonitor = this.removeMonitor.bind(this);
        this.removeMonitors = this.removeMonitors.bind(this);
        this.removeMonitorConfirm = this.removeMonitorConfirm.bind(this);
        this.onRemoveMonitor = this.onRemoveMonitor.bind(this);

        this.addCRM = this.addCRM.bind(this);
        this.addCRMConfirm = this.addCRMConfirm.bind(this);
        this.onAddCRM = this.onAddCRM.bind(this);
        this.exportSelect = this.exportSelect.bind(this);
        this.export = this.export.bind(this);
        this.exportConfirm = this.exportConfirm.bind(this);
        this.onExport = this.onExport.bind(this);

    }

    componentDidMount() 
    {
        this.searchData();

        this.loadMonitorSetting();

        this.loadEarlyWarningData(1);

    }

    drawerRef = (ref) => {
        this.drawerRef = ref;
    }

    messageRef = (ref) => {
        this.messageRef = ref;
    }

    /**
     * tab切换
     * @param {*} riskType 
     */
    changeTab(riskType) 
    {
        this.state["riskType"] = riskType;

        if (riskType !== 2) 
        {
            this.searchData();
        }

        this.setState({ riskType: riskType });
    }

    /**
     * 监控对象搜索
     * @param {*} page 页数
     */
    searchData(page) 
    {
        const { basePath, keyWord, options, riskType, item } = this.state;
        
        let filters = {}, schema = "T001003", sorts = {};

        if (page === undefined) 
        {
            page = 1;
        }

        if (keyWord !== undefined && keyWord !== null && keyWord !== '') 
        {
            filters["ENTNAME"] = "${ENTNAME} has '" + keyWord + "'";
        } else 
        {
            filters = {}
        }

        let params = {
            page: page,
            records: options.records,
            schema: schema,
            filters: filters,
            sorts: sorts
        };

        if (riskType === 1) 
        {
            this.loadEarlyWarningData(1)
        }
        else 
        {
            WidgetAjax.ajax({ url: basePath + '/report/data', params: params, callback: this.onSearchData });
        }
        return filters
    }

    onSearchData(result, params) 
    {
        if (result.status === 0) 
        {
            let { keyWord, options } = this.state;
            options["keyWord"] = keyWord;

            this.setState({ data: result.results, total: result.total, options: options, loading:false});
        }
        else if (result.status === 10)
        {
            Cache.logout(this.props)
        }
    }

    loadMonitorSetting() 
    {
        const { basePath, keyWord } = this.state;
        //OBJTYPE:1, 
        WidgetAjax.ajax({ url: basePath + '/monitor/setting', callback: this.onLoadMonitorSetting });

    }

    onLoadMonitorSetting(result, params) 
    {
        if (result.status === 0) 
        {
            this.state["monitorSettingData"] = result.results;

            this.loadMonitorSettingInfo();
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    loadMonitorSettingInfo() 
    {
        const { basePath } = this.state;

        WidgetAjax.ajax({ url: basePath + '/monitor/setting_info', params: { OBJTYPE: 1 }, callback: this.onLoadMonitorSettingInfo });
    }

    onLoadMonitorSettingInfo(result, params) 
    {
        if (result.status === 0) 
        {
            let { monitorSettingData, monitoringOptions } = this.state;

            if (monitorSettingData.length > 0 && result.results.length > 0)
            {
                for (let item of monitorSettingData) 
                {
                    for (let data of result.results) 
                    {
                        if (item.TYPE === data.TYPE) 
                        {
                            //item["MONITOR"] = data.MONITOR;

                            item["MONITOR"] = true;

                            break;
                        }
                    }
                }
            }

            monitoringOptions["records"] = monitorSettingData.length;

            this.setState({ monitorSettingData: monitorSettingData, monitorSettingDataTotal: monitorSettingData.length, monitoringOptions: monitoringOptions });

        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    // 操作中删除的点击
    onEvent(type, data, value, event) 
    {
        switch (type) 
        {
            case 'remove':
            {
                data = JSON.parse(data);

                this.remove(data);
                break;
            }
            case "transformTEL":
            {
                data = JSON.parse(data);

                return this.transformTEL(data, value);
            }
            case "transformOperations":
            {
                return this.transformOperations(data, value);
            }
            case "toggle":
            {
                this.riskMonitorUpdateSetting(data, value);
                break;
            }
            case "OBJDetail":
            {
                const { riskType } = this.state;

                data = JSON.parse(data);

                this.props.history.push({ pathname: "/home/dynamicCourse", state: { data: data, risk: riskType } });
                break;
            }
            case "transformIcon":
            {
                return this.transformIcon(data, value);
            }
            case "transformTYPE":
            {
                return <img src={require("../img/riskCompass/riskMoitor/" + data.TYPE + ".svg")} alt="es-lint want to get" />
            }
            case "transformToggleOperations":
            {
                return this.transformToggleOperations(data, value);
            }
            case "entityDetail":
            {
                data = JSON.parse(data);

                this.setState({ detailData: data });

                this.drawerRef.open();
                break;
            }
            case "addMonitor":
            {
                data = JSON.parse(data);

                this.addMonitor(data);

                break;
            }
            case "removeMonitor":
            {
                data = JSON.parse(data);

                this.removeMonitor(data);

                break;
            }
            case "addCRM":
            {
                data = JSON.parse(data);

                this.addCRM(data);

                break;
            }
            case "removeCRM":
            {
                data = JSON.parse(data);

                this.removeCRM(data);

                break;
            }
            case "earlyWarningEntityDetail" :
            {
                data = JSON.parse(data);

                this.setState({ detailData: data });

                this.drawerRef.open();
                break;
            }
            default:
                break;
        }
    }

    /**
     * 表格操作转换
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
    transformOperations(data, content) 
    {
        if (content.props !== undefined && content.props.children !== undefined) 
        {
            for (let i = 0; i < content.props.children.length; i++) 
            {
                let child = content.props.children[i];

                if (child.props.className === "addCRM") 
                {
                    if (data.CRM === true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeCRM") 
                {
                    if (data.CRM !== true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "addFavor") 
                {
                    if (data.FAVOR === true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeFavor")
                {
                    if (data.FAVOR !== true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
            }
        }

        return content;
    }

    /**
     * 联系方式转换
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
    transformTEL( data, content )
    {
        if( data.TEL!==undefined && data.TEL!==null && data.TEL.length>0 )
        {
            let value = "", isFirst = true;
            for( let item of data.TEL )
            {
                if( isFirst )
                {
                    value = `<label className='tel'>`+item.tel+`</label>`;
                    isFirst = false;
                }
                else
                {
                    value += `<label className='tel'>`+item.tel+`</label>`;
                }
            }

            return value;
        }
    }


    // 监控
    addMonitor(data) 
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.addMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加到监管对象中吗?`;

        messageOptions["title"] = "添加监管";

        this.state['isBatch'] = false;
        this.state['entityData'] = data;
        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();

    }

    addMonitorConfirm() 
    {
        const { basePath, entityData, isBatch, checkData } = this.state;

        let params = {};
        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params["ENTIDs"] = ENTIDs;
        }
        else 
        {
            params["ENTID"] = entityData.ENTID;
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/add_entity', params: params, callback: this.onAddMonitor, backParam: { data: entityData } });
    }

    onAddMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions, isBatch, checkData } = this.state;

            messageOptions["isMessage"] = true;

            if (isBatch === true) 
            {
                let ENTNAMEs = "", isFirst = true;

                for (let item of checkData) 
                {
                    if (isFirst === true) 
                    {
                        ENTNAMEs = `'` + item.ENTNAME + `'`

                        isFirst = false;
                    }
                    else 
                    {
                        ENTNAMEs += `, '` + item.ENTNAME + `'`
                    }
                }

                if (result.results === checkData.length) 
                {
                    messageOptions["message"] = ENTNAMEs + `' 全部成功添加到监控企业中！`;
                }
                else 
                {
                    messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.results + ` 条成功添加到监控企业中, 有 ` + (checkData.length - result.results) + ` 条失败!`;
                }
            }
            else 
            {
                messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添加到监控企业中！`;
            }

            messageOptions["title"] = "添加监控企业";

            this.state['entityData'] = undefined;
            this.state['checkData'] = [];
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            this.searchData(1);

        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 取消监管
     * @param {*} data 
     */
    removeMonitor(data) 
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.removeMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 从监管对象中移除吗?`;

        messageOptions["title"] = "取消监管";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();
    }
    /**
     * 批量取消监控
     */
    removeMonitors() 
    {
        let { messageOptions, checkData } = this.state, ENTNAMEs = "", isFirst = true;

        messageOptions["isMessage"] = false;

        if (!checkData.length) 
        {
            messageOptions["isMessage"] = true;

            messageOptions["message"] = `请选择取消监控企业`;

            messageOptions["title"] = "取消监控企业";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else 
        {
            for (let item of checkData) 
            {
                if (isFirst === true) 
                {
                    ENTNAMEs = `'` + item.ENTNAME + `'`

                    isFirst = false;
                }
                else 
                {
                    ENTNAMEs += `, '` + item.ENTNAME + `'`
                }
            }

            messageOptions["message"] = `确定要把 '` + ENTNAMEs + `' 取消监控吗?`;

            messageOptions['confirmFunction'] = this.removeMonitorConfirm;

            messageOptions["title"] = "取消监控";

            this.state['isBatch'] = true;
            this.state['entityData'] = undefined;
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }

    removeMonitorConfirm() 
    {
        const { basePath, entityData, isBatch, checkData } = this.state;

        let params = {};
        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData)
            {
                ENTIDs.push(item.ENTID);
            }

            params["ENTIDs"] = ENTIDs;
        }
        else 
        {
            params["ENTID"] = entityData.ENTID;
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/remove_entity', params: params, callback: this.onRemoveMonitor, backParam: { data: entityData } });
    }

    onRemoveMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions, isBatch, checkData } = this.state;

            messageOptions["isMessage"] = true;

            if (isBatch === true) 
            {
                let ENTNAMEs = "", isFirst = true;

                for (let item of checkData) 
                {
                    if (isFirst === true) 
                    {
                        ENTNAMEs = `'` + item.ENTNAME + `'`

                        isFirst = false;
                    }
                    else 
                    {
                        ENTNAMEs += `, '` + item.ENTNAME + `'`
                    }
                }

                if (result.results === checkData.length) 
                {
                    messageOptions["message"] = ENTNAMEs + `' 全部成功取消监控！`;
                }
                else 
                {
                    if(result.result === checkData.length)
                    {
                        messageOptions["message"] = `成功将` + ENTNAMEs + `全部取消监控！`
                    }
                    else
                    {
                        messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.result + ` 条成功取消监控, 有 ` + (checkData.length - result.result) + ` 条失败!`;
                    }
                }
            }
            else 
            {
                messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添从监管对象中移除！`;
            }

            messageOptions["title"] = "取消监管";

            this.state['entityData'] = undefined;
            this.state['checkData'] = [];
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            this.searchData(1);

        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }
    /**
     * 添加种子用户
     */
    // addSeedUser() 
    // {
    // }

    removeSeedUser() 
    {

    }

    /**
     * 添加 CRM
     * @param {*} data 
     */
    addCRM(data) 
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;
        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加至CRM中吗?`;
        messageOptions['confirmFunction'] = this.addCRMConfirm;
        messageOptions["title"] = "添加CRM";
        messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    addCRMConfirm() 
    {
        let { messageOptions, basePath } = this.state,
            data = messageOptions["entData"],
            params = {
                "ENTID": data.ENTID
            }

        WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { Name: data.ENTNAME } });
    }

    onAddCRM(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `已将 ${backParam.Name} 添加至CRM!`;
            messageOptions["title"] = "添加成功";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else if (result === 10) 
        {
            Cache.logout(this.props);
        }
        else if (result.status === -1) 
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！`;
            messageOptions["title"] = "错误";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }

    /**
     * 取消 CRM
     * @param {*} data 
     */
    removeCRM(data) 
    {
        let { messageOptions, checkData } = this.state;

        messageOptions["isMessage"] = false;
        messageOptions["message"] = `确定要将 '` + data.ENTNAME + `' 从CRM中移除吗?`;
        messageOptions['confirmFunction'] = this.removeCRMConfirm;
        messageOptions["title"] = "移出CRM";
        messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    removeCRMConfirm()
     {
        let { messageOptions, basePath } = this.state,
            data = messageOptions["entData"],
            params = {
                "ENTID": data.ENTID
            }

        WidgetAjax.ajax({ url: basePath + '/follow/remove_entity', params: params, callback: this.onRemoveCRM, backParam: { Name: data.ENTNAME } });
    }

    onRemoveCRM(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `已将 ${backParam.Name} 从CRM中移除!`;
            messageOptions["title"] = "移除成功";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else if (result === 10) 
        {
            Cache.logout(this.props);
        }
        else if (result.status === -1)
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！`;
            messageOptions["title"] = "错误";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }


    riskMonitorUpdateSetting(data, MONITOR) 
    {
        const { basePath, monitorSettingData } = this.state;

        let settings = [];

        for (let item of monitorSettingData) 
        {
            let setting = {};

            if (item.TYPE === data.TYPE) 
            {
                setting = {
                    TYPE: item.TYPE,
                    MONITOR: MONITOR
                }
            }
            else 
            {
                setting = {
                    TYPE: item.TYPE,
                    MONITOR: item.MONITOR !== undefined ? item.MONITOR : false
                }

            }
            settings.push(setting);
        }

        let params = {
            "OBJTYPE": 1,
            settings: settings
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/update_setting', params: params, callback: this.onRiskMonitorUpdateSetting });
    }

    onRiskMonitorUpdateSetting(result, params) 
    {
        if ( result.status===0 ) 
        {
            this.loadMonitorSetting();
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    transformToggleOperations(data, content) 
    {
        if (data.MONITOR) 
        {
            return <Toggle checked={data.MONITOR} defaultChecked={data.MONITOR} onChange={(checked) => { this.onEvent("toggle", data, checked) }}></Toggle>
        }
        else 
        {
            return <Toggle checked={false} defaultChecked={data.MONITOR} onChange={(checked) => { this.onEvent("toggle", data, checked) }}></Toggle>
        }
    }

    transformIcon(data, content) 
    {
        return <img src={require("../img/riskCompass/riskMoitor/" + data.TYPE + ".svg")} alt="es-lint want to get" />
    }

    //搜索
    keyWordOnChange(value, event) 
    {
        if (value === "")
        {
            this.setState({ keyWord: value }, function () 
            {
                this.searchData(1);
            });

        } 
        else 
        {
            this.setState({ keyWord: value });
        }

    }

    /**
     * 回调函数
     * @param {*} result 返回结果
     * @param {*} params 传递参数
     */
    onReadEntity(result, params) 
    {
        const { keyWord, options } = this.state

        if (result.status === 0) 
        {
            options['keyWord'] = keyWord

            this.setState({ data: result.results, total: result.total, options: options });

        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props)
        }
    }

    /**
     * 翻页
     * @param {*} page 
     */
    pageTurning(page) 
    {
        this.searchData(page);
    }

    loadEarlyWarningData(page) 
    {
        const { basePath, earlyWarningOptions, rangDate, keyWord } = this.state;

        if (page === undefined || page === null) 
        {
            page = 1;
        }

        let params = {
            STARTDATE: rangDate.startDate,
            ENDDATE: rangDate.endDate,
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/warn', params: params, callback: this.onLoadEarlyWarningData });
    }

    onLoadEarlyWarningData(result, params) 
    {
        if (result.status === 0) 
        {
            this.setState({ earlyWarningData: result.results, earlyWarningTotal: result.total,isLoading:false});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        else if (result.status === 13) 
        {
            this.setState({ earlyWarningData: [], earlyWarningTotal: undefined,isLoading:false});
        }
    }

    /**
     * 监控预警翻页
     * @param {*} page 
     */
    earlyWarningPageTurning(page) 
    {
        this.loadEarlyWarningData(page);
    }

    /* 
    * 删除弹窗
    */
    remove(data) 
    {
        this.state['removeData'] = data

        let { messageOptions } = this.state
        messageOptions["isMessage"] = false;

        messageOptions['message'] = `您确定要将 '` + data.ENTNAME + ` '移出监管对象吗?`;

        messageOptions['confirmFunction'] = this.confirmRemove;

        this.state['messageOptions'] = messageOptions

        this.messageRef.open()
    }

    /**
     * 删除确认函数
     */
    confirmRemove() 
    {
        const { basePath, removeData } = this.state;

        let params = {
            OBJTYPE: 1,
            OBJID: removeData.OBJID
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/remove_object', params: params, callback: this.onconfirmRemove });
    }

    onconfirmRemove(result, params) 
    {
        let { messageOptions } = this.state

        messageOptions["isMessage"] = true;

        if (result.status === 0) 
        {
            messageOptions['message'] = '删除成功'

        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        else 
        {
            messageOptions['message'] = '删除失败'
        }

        this.searchData()
        this.messageRef.open()
    }

    /**
     * 新增onchange
     * @param {*} value 
     * @param {*} type 
     */
    InputOnchange(value, type) 
    {
        switch (type) 
        {
            case 'Input':
            {
                this.relevanceSearch(value)
                break;
            }
            case 'textarea':
            {
                this.state['textarea'] = value
                break;
            }
            default:
                break;
        }
    }


    /**
     * 新增的相关联对象搜索
     * @param {*} value 
     */
    relevanceSearch(value) 
    {
        const { keyWord, input, basePath } = this.state;

        this.state['relevance'] = [];

        let params = {
            OBJTYPE: 1,
            name: value,
        }

        this.setState({ input: value });

        WidgetAjax.ajax({ url: basePath + '/object/tip', params: params, callback: this.onRelevanceSearch });
    }

    /**
     * 回调函数
     * @param {*} result 返回结果
     * @param {*} params 传递参数
     */
    onRelevanceSearch(result, params) 
    {

        if (result.status === 0) 
        {
            this.setState({ relevance: result.results });

        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props)
        }
    }


    /**
     * 新增监控对象弹框确认的回调函数
     */
    confirmAdd() 
    {
        const { input, basePath, OBJID } = this.state;

        let params = {
            OBJTYPE: 1,
            OBJNAME: input,
            OBJID: OBJID
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/add_object', params: params, callback: this.onconfirmAdd });
    }

    tableOnCheck(data) 
    {
        this.state["checkData"] = data;
    }

    /**
    * 删除
    */
    delete(type) 
    {
        let { checkedKeys, messageOptions } = this.state

        let delType = type === 1 ? '监控' : type === 2 ? 'CRM' : '种子用户';

        if (!checkedKeys) return;

        let Objs, isFirst = true;
        for (let item of checkedKeys) 
        {
            if (isFirst) 
            {
                Objs = item.ENTNAME;

                isFirst = false;
            }
            else 
            {
                Objs += ", " + item.ENTNAME;
            }
        }

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.deleteConfirm;

        messageOptions['message'] = `您确定要将${Objs}移出${delType}对象吗?`;

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    deleteConfirm() 
    {
        const { checkedKeys, basePath } = this.state;

        let OBJIDs = [];

        for (let item of checkedKeys) 
        {
            OBJIDs.push(item.OBJID);
        }

        let params = {
            OBJTYPE: 1,
            OBJIDs: OBJIDs
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/remove_object', params: params, callback: this.onDelete });
    }

    onDelete(result, params) 
    {
        let { messageOptions } = this.state

        messageOptions["isMessage"] = true;

        if (result.status === 0) 
        {
            messageOptions['message'] = '删除成功'
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        else 
        {
            messageOptions['message'] = '删除失败'
        }

        this.searchData();

        this.messageRef.open();
    }

    async onDateSelect(value) 
    {
        if (value !== undefined) 
        {
            await this.setState({ rangDate: { startDate: value.start, endDate: value.end }, dateStart: value.start,dateEnd: value.end })

             this.loadEarlyWarningData()
        }
    }

    enterpriseSearch(btn) 
    {
        if (btn) 
        {
            this.setState({
                flags: true
            });
        }

        this.searchData()
    }

    //搜索键盘事件
    onKeyDown(e, btn) 
    {
        if (e.keyCode === 13) 
        {
            this.searchData(1);

            if (btn) 
            {
                this.setState({ flags: true});
            }
        }
    }
    /**
     * 导出选择
     * @param {*} eventKey 
     * @param {*} event 
     */
    exportSelect(eventKey, event) 
    {
        this.export(eventKey);
    }

    /**
    * 导出按钮
    */
    export(type) 
    {
        let { messageOptions, total, checkData } = this.state;

        // 
        messageOptions["isMessage"] = false;

        if (type === "1") 
        {
            if (checkData === undefined || checkData === null || checkData.length === 0) {
                messageOptions["isMessage"] = true;

                messageOptions["message"] = `没有选中的记录?`;

                messageOptions["title"] = "导出";

            }
            else 
            {
                messageOptions["message"] = `确定要导出当前选中的记录吗?`;
            }
        }
        else if (type === "2") 
        {
            messageOptions["message"] = `确定要导出符合当前条件的前10条记录吗?`;
        }
        else if (type === "3") 
        {
            messageOptions["message"] = `确定要导出符合当前条件的前50条记录吗?`;
        }
        else if (type === "4") 
        {
            messageOptions["message"] = `确定要导出符合当前条件的前100条记录吗?`;
        }
        else 
        {
            messageOptions["message"] = `确定要导出符合当前条件的全部记录吗?`;
        }

        messageOptions['confirmFunction'] = this.exportConfirm;

        messageOptions["title"] = "导出确认";

        this.state['messageOptions'] = messageOptions;
        this.state['exportType'] = type;

        this.messageRef.open();
    }

    exportConfirm() 
    {
        const { basePath, checkData, exportType } = this.state;

        let filters = {}, schema = "T001003", sorts = {};

        if (exportType === "1") 
        {
            if (checkData !== undefined && checkData.length > 0) 
            {
                let isFirst = true, content = "";
                for (let item of checkData) 
                {
                    if (isFirst) 
                    {
                        content = "'" + item.ENTID + "'";
                        isFirst = false;
                    }
                    else 
                    {
                        content += ",'" + item.ENTID + "'";
                    }

                }

                filters["ENTID"] = "${ENTID} IN (" + content + ")";
            }

        }
        else 
        {
            filters = this.searchData();

        }

        let params = {
            schema: schema,
            filters: filters
        }


        switch (exportType) 
        {
            case "2":
            {
                params["page"] = 1;
                params["records"] = 10;
                break;
            }
            case "3":
            {
                params["page"] = 1;
                params["records"] = 50;
                break;
            }
            case "4":
            {
                params["page"] = 1;
                params["records"] = 100;
                break;
            }
            default:
                break;

        }

        WidgetAjax.ajax({ url: basePath + '/report/excel', params: params, callback: this.onExport });
    }

    onExport(result, params) 
    {
        const { basePath, messageOptions } = this.state;

        let fileName = "export.xlsx";

        if (result.status === 0) 
        {
            let token = result.token;

            let url = basePath + "/report/download";

            WidgetAjax.exportFile({ url: url, params: { token: token, fileName: fileName } });

            // Widget.exportFile(url);
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props.parentProps);
        }
        else 
        {
            messageOptions["isMessage"] = true;

            messageOptions["message"] = '数据导出失败！';

            messageOptions["title"] = "数据导出";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }

    render() 
    {
        const { columns, data, total, options, enterprise, enterpriseText, riskType,
            monitoringColumn, monitoringOptions, monitorSettingData, monitorSettingDataTotal,
            earlyWarningColumns, earlyWarningData, earlyWarningOptions, earlyWarningTotal,
            keyWord, messageOptions, relevance, input, tabs, dateOptions, detailData, drawerOptions, flags, loading, flag, isLoading,dateStart
            ,dateEnd} = this.state;
        enterprise['confirmFunction'] = this.confirmAdd;
        enterpriseText['confirmFunction'] = this.confirmText;
        // let currentMonth = Widget.dateFormatter(new Date(), "YYYYMMDD");
        // let dateStart = Widget.computeDate(new Date(), "month", -1);
        // dateStart = Widget.dateFormatter(dateStart, "YYYYMMDD");
        // console.log(earlyWarningData)
        // let dateStart = undefined, dateEnd = undefined;
        return (
            <div className="page page-overflow enterprise-list">
                <div className='tabs'>
                    <div className="title title-tabs-list">
                        {
                            tabs.map(item => {
                                return <p key={item.key} className={`${riskType === item.key ? 'activeTab click' : 'click'}`} onClick={() => { this.changeTab(item.key) }}>{item.title}</p>
                            })
                        }
                    </div>
                    <div className='tab-right'>
                        {riskType === 1 && <WidgetDatePicker onSelect={(e) => { this.onDateSelect(e) }} defaultValue={{ dateStart: dateStart, dateEnd: dateEnd, dateType: "date" }} options={dateOptions} />}
                        {
                            riskType != 2 && <div className="content-search" >
                                <InputGroup className="InputGroup"  >
                                    <Input name="Serchkey" defaultValue={keyWord} placeholder="请输入搜索内容" onChange={(e) => { this.keyWordOnChange(e) }} onKeyDown={(e) => { this.onKeyDown(e, 'btn') }} />
                                </InputGroup>
                                <img src = {Magnifier} className='MagnifierSearch'/>
                            </div>
                        }
                        {/* {riskType === 1 && <p className='search-btn' onClick={() => { this.enterpriseSearch('btn') }}>搜索</p>} */}
                        {/* <p className='go-search-tag' onClick={() => { this.props.history.push({ pathname: "/home/searchTag" }); }}>高级搜索</p> */}
                    </div>
                </div>

                {/* 监控对象 */}
                <div className="content white border" style={riskType !== 0 ? { height: 'calc(100% - 74px)' } : { minHeight: 'calc(100% - 122px)' }} >
                    <div style={riskType === 0 ? { display: '', marginBottom: 0, borderBottom: 'none' } : { display: 'none', marginBottom: 0, borderBottom: 'none' }}  >
                        <div className='search-left' style={{width:'100%',height:"56px",lineHeight:"55px",padding:"0 10px 0 30px",borderBottom:"1px solid #F7FAFF"}}>
                            <p>为您找到 <span className='num' >{total}</span> 家企业</p>
                            <div className="monitoring" style={{float:'right',position:"relative",top:"6px",right:"11px"}}>
                                <div className="addButton click margin" onClick={() => { this.removeMonitors() }}>
                                    <span>取消监控</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 监控列表 */}
                    <div className="content-chart-height content-report-height content-table white" style={riskType === 1 ? { display: '' } : { display: 'none' }}>
                        <WidgetPageTable tableRowHight={55} onCheck={this.tableOnCheck} options={earlyWarningOptions} columns={earlyWarningColumns}
                            data={earlyWarningData} total={earlyWarningTotal} notify={this.onEvent} pageTurning={this.earlyWarningPageTurning} loading={isLoading}></WidgetPageTable>
                    </div>

                    {/* 监控企业 */}
                    <div className="content-chart-height content-report-height content-table white" style={riskType === 0 ? { display: '',marginTop:0 } : { display: 'none' }}>
                        <WidgetPageTable onCheck={this.tableOnCheck} options={options} columns={columns}
                            data={data} total={total} notify={this.onEvent} pageTurning={this.pageTurning} loading={loading}></WidgetPageTable>
                    </div>

                    {/* 监控事项 */}
                    <div className="content-chart-height content-report-height  content-table white" style={riskType === 2 ? { display: '' } : { display: 'none' }}>
                        <WidgetTable tableRowHight={55} options={monitoringOptions} columns={monitoringColumn}
                            data={monitorSettingData} total={monitorSettingDataTotal} notify={this.onEvent} pageTurning={this.pageTurning}></WidgetTable>
                    </div>

                </div>

                <WidgetMessage options={messageOptions} onRef={this.messageRef} />

                <div className="scroll">
                    <WidgetDrawer options={drawerOptions} onRef={this.drawerRef} >
                        <div className="frame-body" ref="head">
                            <EntityDetail data={detailData} flag={flag} ></EntityDetail>
                        </div>
                    </WidgetDrawer>
                </div>
            </div>

        )
    }
}

export default RiskMonitor